import { useEffect, useState } from "react"
import usePersonStore from "../store/personStore"
import useSelectStudent from "./hooks/useSelectedStudent"
import { useParams } from "react-router"
import { Box, Collapse, Paper, Select, Typography, Grid, MenuItem, InputLabel, FormControl, Checkbox, FormControlLabel } from "@mui/material"
import { Form } from "react-final-form"
import { useLazyQuery, useMutation, useQuery } from "@apollo/client"
import { GET_COMPANY_LOCATIONS, GET_PEOPLE_WITH_SESSION_COUNT } from "../../features/graphql/query"
import { Location, Person } from "../../__generated__/graphql"
import { LoadingButton } from "@mui/lab"
import { TRANSFER_STUDENT_LOCATION } from "../../features/graphql/mutation"
import { STUDENT_QUERY } from "./StudentManagePage"
import { useManageModal, Header } from "ui"
import { PEOPLE_PAGE_QUERY } from "ft-shared-graphql"


const mapPersonData = (data: any) => {
    const node = data.node;
    return {
        ...node,
        locations: node.locations?.edges?.map((x: any) => x.node.id)
    }
}

const TransferStudentLocationPage = ({ onBack }: { onBack: () => void }) => {
    const params = useParams()
    const { setSelectedStudent } = useSelectStudent(params.sid)

    const companyId = usePersonStore(state => state.company.id)
    const { student } = useSelectStudent(params.sid)
    const [formState, setFormState] = useState<{
        locations: Location[],
        persons: Person[]
        selectedPersons: string[],
        selectedLocation: string | null
    }>({
        locations: [],
        persons: [],
        selectedPersons: [],
        selectedLocation: null
    })
    const { openModal } = useManageModal();
    const [fetch, { data, loading }] = useLazyQuery(PEOPLE_PAGE_QUERY, {
        notifyOnNetworkStatusChange: true,
        variables: { role: "LAUNCH_SELF_ACCESS", first: 100 }

    })
    const { loading: locationLoading, data: locationData } = useQuery(GET_COMPANY_LOCATIONS, {
        notifyOnNetworkStatusChange: true,
        variables: {
            companyId: companyId!,
            query: "",
            first: 100
        }
    })
    const [transferStudentLocation] = useMutation(TRANSFER_STUDENT_LOCATION, {
        refetchQueries: [{
            query: STUDENT_QUERY,
            variables: {
                studentId: params.sid

            }
        },]
    })
    useEffect(() => {
        if (data) {
            const _persons = data?.people?.edges?.map(mapPersonData) ?? [];
            // .filter((person: any) => person.locations.some((e: any) => e == formState.selectedLocation))
            const _preSelectedPeople: string[] = [];
            for (let i = 0; i < _persons.length; i++) {
                for (let k = 0; k < (student?.persons?.edges?.length ?? 0); k++) {
                    const studentPerson = student?.persons?.edges ? student?.persons?.edges[k].node : null;
                    if (!studentPerson) return;
                    const isAssigned = studentPerson?.id == _persons[i].id
                    if (isAssigned) {
                        if (formState.selectedPersons.includes(studentPerson?.id)) continue;
                        _preSelectedPeople.push(studentPerson?.id)
                    }
                }
            }
            setFormState(prevState => ({
                ...prevState,
                persons: _persons,
                selectedPersons: _preSelectedPeople
            }))
        }
    }, [loading, data])
    useEffect(() => {
        if (locationData) {
            const _locations = locationData?.locationsByCompanyId?.edges?.map((e: any) => e.node)
            setFormState(prevState => ({
                ...prevState,
                locations: _locations.filter((location: Location) => location.id != student?.locationId)
            }))
        }
    }, [locationLoading, locationData])

    const fetchLocationPersons = (locationId: string) => {
        fetch({
            variables: {
                first: 100,
                query: "",
                after: null,
                locationId: formState.selectedLocation
            }
        })
    }
    useEffect(() => {
        if (!formState.selectedLocation) return;
        fetchLocationPersons(formState.selectedLocation)
    }, [formState.selectedLocation])
    const caution = () => {
        openModal({ type: "MOVE_STUDENT_WARNING", onConfirm: async () => await handleSubmit?.(), confirmButtonLabel: "Yes", cancelButtonLabel: "Cancel" })
    }
    const handleSubmit = async () => {
        try {
            const response = await transferStudentLocation({
                variables: {
                    studentId: params.sid,
                    locationId: formState.selectedLocation,
                    personIds: formState.selectedPersons
                }
            })
            if (response.data) {
                openModal({ type: "SAVED_ASSIGNMENTS", cancelButtonLabel: "Close" })
                setSelectedStudent(response?.data.student);
            }
        } catch (err) {
            console.log("some error occured")
        }
    }
    return (
        <Paper >
            <Header
                title={`Transfer Child: ${student?.firstName} ${student?.lastName} to a new location`}
                subtitle={`Original Location: ${student?.location?.name}`}
                onBack={onBack} />
            <Box sx={{ padding: 2 }}>
                <Form initialValues={{
                    selectedLocation: null,
                    selectedPersons: []
                }}
                    onSubmit={caution}
                    render={({ handleSubmit, form, submitting }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid style={{ marginTop: 0 }} container spacing={4} rowSpacing={4}>
                                <Grid size={6}>
                                    <FormControl fullWidth>
                                        {/* <Typography>Select a new Location</Typography> */}
                                        <InputLabel id="selectLocationLabel">Select A New Location</InputLabel>
                                        <Select value={formState.selectedLocation ?? ""}
                                            fullWidth
                                            labelId="selectLocationLabel"
                                            label="Select A New Location"
                                            onChange={(event) => setFormState(prevState => ({ ...prevState, selectedLocation: event.target.value }))}>
                                            {formState?.locations?.map((location) => (
                                                <MenuItem key={location.id} value={location.id}>
                                                    {location.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
                                <Grid size={12}>
                                    <Collapse in={formState.selectedLocation != null}>
                                        <Box sx={{ mt: 2 }}>
                                            <Grid container spacing={2}>
                                                {formState.persons.map((person) => (
                                                    <Grid size={6} key={person.id}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    disabled={
                                                                        (student?.references ?? 0) <= 1 &&
                                                                        formState.selectedPersons.length <= 1 && formState.selectedPersons.includes(person.id)
                                                                    }
                                                                    checked={formState.selectedPersons.includes(person.id)}
                                                                    onChange={() => {
                                                                        setFormState(prev => {
                                                                            const exists = prev.selectedPersons.includes(person.id);

                                                                            return {
                                                                                ...prev,
                                                                                selectedPersons: exists
                                                                                    ? prev.selectedPersons.filter(id => id !== person.id)
                                                                                    : [...prev.selectedPersons, person.id]
                                                                            };
                                                                        });
                                                                    }}
                                                                />
                                                            }
                                                            label={`${person.firstName} ${person.lastName}`}
                                                        />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Box>
                                    </Collapse>

                                </Grid>
                                <LoadingButton disableElevation
                                    loading={submitting}
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    disabled={formState.selectedPersons.length < 1}
                                >
                                    Save
                                </LoadingButton>
                            </Grid>
                        </form>
                    )}

                />
            </Box>

        </Paper>

    )
}

export default TransferStudentLocationPage



